// 路由,路径相关
export const PATH_LOGIN = "/login";
export const PATH_UPLOAD_IMG = "/uploatImg";
export const PATH_AUDIT = "/audit";
export const PATH_EDIT = "/edit";
export const PATH_INDEX = "/index";
export const PATH_MANAGE = "/manage";
export const PATH_DETAILS = "/details";
export const PATH_RESETPWD = "/resetPwd";
export const PATH_RSETTAB = "/setTab";
export const PATH_NEWS_LIST = "/news/list";
export const PATH_NEWS_ADD = "/news/add";
export const PATH_MESSAGE_LIST = "/message/list";
export const PATH_MESSAGE_ADD = "/message/add";



// WEBPACK FOOTER //
// ./src/constants/URL.js